import { PERMISOS_CARGA_MASIVA, PERMISOS_CONFIGURACION_OPCIONES, PERMISOS_GESTION_CLIENTE, PERMISOS_GRUPOS_PERMISOS, PERMISOS_MAPEO_CAMPOS, PERMISOS_PLANTILLAS, PERMISOS_PERFECCIONAMIENTO, PERMISOS_PROCESO_NOTIFICACION, PERMISOS_PROCESO_NOTIFICACION_VENTA, PERMISOS_VENTA_FACTURAS } from '@shared/constants/permisos';

export interface ElementoMenu {
  titulo: string;
  icono?: string;
  ruta?: string;
  hijos?: ElementoMenu[];
  expandido?: boolean;
  mostrarEnHover?: boolean;
  descripcion?: string;
  permisoRequerido?: string;
  permisosAlternativos?: readonly string[];
  badge?: boolean;
}


export const ELEMENTOS_MENU: ElementoMenu[] = [
  {
    titulo: 'Inicio',
    icono: 'pi-home',
    ruta: '/',
    descripcion: 'Ir al panel principal'
  },
  {
    titulo: 'Radicar negocio',
    icono: 'pi-file-edit',
    descripcion: 'Radicación y gestión de negocios',
    hijos: [
      { 
        titulo: 'Cargar facturas', 
        icono: 'receipt', 
        ruta: '/radicaciones/factura', 
        descripcion: 'Gestionar facturas',
        permisoRequerido: 'RadicacionFactura.Crear'
      },
      { 
        titulo: 'Validar factura', 
        icono: 'pi-check-circle', 
        ruta: '/facturas/validar-factura', 
        descripcion: 'Validar y procesar facturas',
        permisoRequerido: 'RadicacionFactura.Validar'
      },
      { 
        titulo: 'Carga instrucciones giro', 
        icono: 'pi-send', 
        ruta: '/radicaciones/instruccion-giro', 
        descripcion: 'Crear nueva instrucción de giro',
        permisoRequerido: 'RadicacionInstruccionesGiro.Crear'
      },
      { 
        titulo: 'Validación de instrucciones de giro', 
        icono: 'pi-list-check', 
        ruta: '/radicaciones/revision-instruccion-giro', 
        descripcion: 'Revisar instrucciones de giro pendientes',
        permisoRequerido: 'RadicacionInstruccionesGiro.Ver'
      }
    ]
  },
  {
    titulo: 'Gestión operativa',
    icono: 'pi-briefcase',
    descripcion: 'Gestión operativa y validaciones',
    hijos: [
      { 
        titulo: 'Sarlaft manual', 
        icono: 'pi-shield', 
        ruta: '/gestion-operativa/sarlaft-manual', 
        descripcion: 'Validación manual SARLAFT',
        permisoRequerido: 'SarlafManual.Ver'
      }
    ]
  },
  {
    titulo: 'Facturas',
    icono: 'pi-file',
    descripcion: 'Gestión de facturas',
    hijos: [
      { 
        titulo: 'Notificar facturas', 
        icono: 'pi-send', 
        ruta: '/facturas/notificar', 
        descripcion: 'Gestiona y notifica tus facturas radicadas',
        permisoRequerido: 'Notificaciones.Ver'
      },
      { 
        titulo: 'Facturas en proceso', 
        icono: 'pi-list', 
        ruta: '/facturas/gestion-factor', 
        descripcion: 'Gestión de facturas en perfeccionamiento',
        permisoRequerido: PERMISOS_PERFECCIONAMIENTO.VER
      },
      { 
        titulo: 'Proceso de notificación', 
        icono: 'pi-bell', 
        ruta: '/facturas/proceso-notificacion', 
        descripcion: 'Proceso de notificación de facturas',
        permisoRequerido: PERMISOS_PROCESO_NOTIFICACION.VER
      },
      { 
        titulo: 'Proceso de notificación', 
        icono: 'pi-bell', 
        ruta: '/facturas/proceso-notificacion-emisor', 
        descripcion: 'Ver mis procesos de notificación como emisor',
        permisoRequerido: PERMISOS_PROCESO_NOTIFICACION.VER_EMISOR
      }
    ]
  },
  {
    titulo: 'Venta de facturas',
    icono: 'pi-tag',
    descripcion: 'Gestión de venta de facturas a fondeadores',
    hijos: [
      {
        titulo: 'Asignación a fondeador',
        icono: 'pi-user-plus',
        ruta: '/facturas/fondeador',
        descripcion: 'Asignar facturas a fondeadores',
        permisoRequerido: PERMISOS_VENTA_FACTURAS.VER
      },
      {
        titulo: 'Aprobación de ventas',
        icono: 'pi-check-square',
        ruta: '/facturas/aprobacion-fondeador',
        descripcion: 'Aceptar o rechazar facturas asignadas como fondeador',
        permisoRequerido: PERMISOS_VENTA_FACTURAS.APROBAR
      },
      {
        titulo: 'Notificación de la Venta',
        icono: 'pi-bell',
        ruta: '/facturas/proceso-notificacion-venta',
        descripcion: 'Consultar los procesos de notificación de venta',
        permisoRequerido: PERMISOS_PROCESO_NOTIFICACION_VENTA.VER
      }
    ]
  },
  {
    titulo: 'Confirming',
    icono: 'pi-sync',
    descripcion: 'Operación de confirming del Deudor',
    hijos: [
      {
        titulo: 'Mapeo de campos',
        icono: 'pi-arrow-right-arrow-left',
        ruta: '/confirming/mapeo-campos',
        descripcion: 'Emparejar las columnas de los archivos del Deudor con los campos del sistema',
        permisosAlternativos: Object.values(PERMISOS_MAPEO_CAMPOS)
      },
      {
        titulo: 'Carga masiva',
        icono: 'pi-upload',
        ruta: '/confirming/carga-masiva',
        descripcion: 'Cargar masivamente los archivos del Deudor con su mapeo de campos vigente',
        permisosAlternativos: PERMISOS_CARGA_MASIVA
      }
    ]
  },
  {
    titulo: 'Configuración',
    icono: 'pi-cog',
    descripcion: 'Configuración del sistema',
    hijos: [
      { 
        titulo: 'Gestión de plantillas', 
        icono: 'pi-file-edit', 
        ruta: '/plantillas', 
        descripcion: 'Crear y editar plantillas de documentos',
        permisoRequerido: PERMISOS_PLANTILLAS.ADMINISTRAR_PLANTILLA
      },
      { 
        titulo: 'Solicitudes de aprobación', 
        icono: 'pi-check-square', 
        ruta: '/plantillas/aprobar', 
        descripcion: 'Gestionar solicitudes de aprobación de plantillas',
        permisoRequerido: PERMISOS_PLANTILLAS.APROBAR_PLANTILLA,
        badge: true
      },
      {
        titulo: 'Gestión de cliente',
        icono: 'pi-building',
        ruta: '/configuracion/gestion-cliente',
        descripcion: 'Administrar la información básica de los clientes',
        permisosAlternativos: [PERMISOS_GESTION_CLIENTE.GESTIONAR_TODOS, PERMISOS_GESTION_CLIENTE.GESTIONAR_PROPIA]
      },
      {
        titulo: 'Gestionar el Fondeador',
        icono: 'pi-wallet',
        ruta: '/configuracion/gestionar-fondeador',
        descripcion: 'Administrar la información de su fondeador',
        permisoRequerido: PERMISOS_GESTION_CLIENTE.GESTIONAR_FONDEADOR
      }
    ]
  },
  {
    titulo: 'Administrar usuarios',
    icono: 'pi-users',
    descripcion: 'Administración de opciones y permisos de usuarios',
    hijos: [
      {
        titulo: 'Configuración de opciones',
        icono: 'pi-sliders-h',
        ruta: '/administracion/configuracion-opciones',
        descripcion: 'Configurar la naturaleza y los tipos y líneas de negocio de las opciones del sistema',
        permisoRequerido: PERMISOS_CONFIGURACION_OPCIONES.GESTIONAR
      },
      {
        titulo: 'Perfilamiento de usuarios',
        icono: 'pi-id-card',
        ruta: '/administracion/grupos-permisos',
        descripcion: 'Crear y administrar grupos de permisos para asignar a usuarios',
        permisoRequerido: PERMISOS_GRUPOS_PERMISOS.GESTIONAR
      }
    ]
  }
];


export function getElementoMenuPorRuta(ruta: string, elementos: ElementoMenu[] = ELEMENTOS_MENU): ElementoMenu | undefined {
  for (const elemento of elementos) {
    if (elemento.ruta === ruta) {
      return elemento;
    }
    
    if (elemento.hijos) {
      const encontrado = getElementoMenuPorRuta(ruta, elemento.hijos);
      if (encontrado) {
        return encontrado;
      }
    }
  }
  
  return undefined;
}

export function getTodasLasRutas(elementos: ElementoMenu[] = ELEMENTOS_MENU): string[] {
  const rutas: string[] = [];
  
  const extraerRutas = (items: ElementoMenu[]): void => {
    for (const item of items) {
      if (item.ruta) {
        rutas.push(item.ruta);
      }
      
      if (item.hijos) {
        extraerRutas(item.hijos);
      }
    }
  };
  
  extraerRutas(elementos);
  return rutas;
}